import { createAction, props } from '@ngrx/store';

export enum AuthTypes {
  SetCurrentUser = '[Auth] Set Current User',
  detachContext = '[Auth] Detach Context',
  SetOtpResponse = '[Auth] Set OTP Response'
}

const SetCurrentUser = createAction(
  AuthTypes.SetCurrentUser,
  props<{ user: any }>()
);

const detachContext = createAction(AuthTypes.detachContext);

const SetOtpResponse = createAction(
  AuthTypes.SetOtpResponse,
  props<{ otpResponse: any }>()
);

const AuthActions = {
  SetCurrentUser,
  detachContext,
  SetOtpResponse
};

export default AuthActions;
